import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingListGroup: false,
  loadingCreateGroup: false,
  loadingUpdateOrder: false,
  loadingUpdateKey: false,
  loadingDelete: false,
  loadingListMappingH2H: false,
  loadingUpdateMarketName: false,
  loadingCreateMappingMarket: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_GET_MARKET_GROUP: (s, data) => (s.loadingListGroup = data),
    LOAD_CREATE_GROUP: (s, data) => (s.loadingCreateGroup = data),
    LOAD_UPDATE_ORDER_NUMBER: (s, data) => (s.loadingUpdateOrder = data),
    LOAD_UPDATE_KEYWORD: (s, data) => (s.loadingUpdateKey = data),
    LOAD_DELETE: (s, data) => (s.loadingDelete = data),
    LOAD_LIST_MAPPING_H2H: (s, data) => (s.loadingListMappingH2H = data),
    LOAD_UPDATE_MARKET_NAME: (s, data) => (s.loadingUpdateMarketName = data),
    LOAD_CREATE_MAPPING_MARKET: (s, data) =>
      (s.loadingCreateMappingMarket = data),
  },

  actions: {
    async getMarketGroups({ commit }, sportId) {
      commit("LOAD_GET_MARKET_GROUP", true);
      try {
        const res = await this.$api.get(`/v1/portal/sport-events/market-group/${sportId}`, {
          params: {
            limit: 100,
            page: 1,
          },
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_GET_MARKET_GROUP", false);
      }
    },
    async createMarketGroup({ commit }, params) {
      commit("LOAD_CREATE_GROUP", true);
      try {
        const { sportId, ...rest } = params;
        const res = await this.$api.post(
          `/v1/portal/sport-events/market-group/${sportId}`,
          rest,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_GROUP", false);
      }
    },
    async updateOrderNumberGroup({ commit }, params) {
      commit("LOAD_UPDATE_ORDER_NUMBER", true);
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-events/market-group/update",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_ORDER_NUMBER", false);
      }
    },
    async updateGroupKey({ commit }, params) {
      commit("LOAD_UPDATE_KEYWORD", true);
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-events/market-group/update",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_KEYWORD", false);
      }
    },
    async deleteGroupOrKeyword({ commit }, params) {
      commit("LOAD_DELETE", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-events/market/group/delete",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE", false);
      }
    },
    async updateOrderNumberKeyword({ commit }, params) {
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-events/market-group/update",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getListMappingH2H({ commit }, params) {
      commit("LOAD_LIST_MAPPING_H2H", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/sport-config/crawling-markets?source=sporting",
          { params },
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_MAPPING_H2H", false);
      }
    },
    async updateMappingH2HMarket({ commit }, params) {
      commit("LOAD_UPDATE_MARKET_NAME", true);
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-config/crawling-market",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_MARKET_NAME", false);
      }
    },
    async createMarketMappingH2H({ commit }, params) {
      commit("LOAD_CREATE_MAPPING_MARKET", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-config/crawling-market",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_MAPPING_MARKET", false);
      }
    },
    async updateOrderNumberListMappingH2H({ commit }, params) {
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-config/crawling-market/order-number",
          params,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deleteCrawlingH2HMarket({ commit }, id) {
      commit("LOAD_DELETE", true);
      try {
        const res = await this.$api.delete(
          `/v1/portal/sport-config/crawling-market/${id}`,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE", false);
      }
    },
    async updateOrderNumberKeyword({ commit }, params) {
      try {
        const res = await this.$api.put(
          "/v1/portal/sport-events/market-group/update",
          params
        );
           return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
 
    async getLeagueMapList(_, params) {
      try {
        const res = await this.$api.get("/v1/portal/sport-cast/league-map", { params });
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async createLeagueMap(_, params) {
      try {
        const res = await this.$api.post("/v1/portal/sport-cast/league-map", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateLeagueMap(_, params) {
      try {
        const { id, ...rest } = params;
        const res = await this.$api.put(`/v1/portal/sport-cast/league-map/${id}`, rest);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deleteLeagueMap(_, id) {
      try {
        const res = await this.$api.delete(`/v1/portal/sport-cast/league-map/${id}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getTeamMapList(_, params) {
      try {
        const res = await this.$api.get("/v1/portal/sport-cast/team-map", { params });
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async createTeamMap(_, params) {
      try {
        const res = await this.$api.post("/v1/portal/sport-cast/team-map", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateTeamMap(_, params) {
      try {
        const { id, ...rest } = params;
        const res = await this.$api.put(`/v1/portal/sport-cast/team-map/${id}`, rest);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deleteTeamMap(_, id) {
      try {
        const res = await this.$api.delete(`/v1/portal/sport-cast/team-map/${id}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
  },
};
